import * as React from 'react';
import { useViewport } from '../viewport-provider';
import { useMaxViewport } from './max-viewport';
/**
 * Parent container for the other Viewport components:
 * `<ViewSmall>`, `<ViewMedium>`, `<ViewLarge>`,`<ViewExtraLarge>`
 */
var Viewport = function (_a) {
    var children = _a.children;
    var _b = useViewport(), viewSizes = _b.viewSizes, validViewSize = _b.validViewSize;
    var maxSize = useMaxViewport();
    var appliedViewSize = maxSize && viewSizes[maxSize] < validViewSize ? viewSizes[maxSize] : validViewSize;
    function validChild() {
        var validChild = null;
        React.Children.forEach(children, function (child) {
            var childViewSize = child.type && viewSizes[child.type.viewSize];
            if (typeof childViewSize === 'number' && childViewSize <= appliedViewSize) {
                if (!validChild) {
                    validChild = child;
                }
                else if (childViewSize > viewSizes[validChild.type.viewSize]) {
                    validChild = child;
                }
            }
        });
        return validChild;
    }
    return React.createElement(React.Fragment, null, validChild());
};
export default Viewport;
//# sourceMappingURL=viewport.js.map